// Sdílené pomocné funkce.

export function esc(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

const MONTHS = ['ledna', 'února', 'března', 'dubna', 'května', 'června',
    'července', 'srpna', 'září', 'října', 'listopadu', 'prosince'];
const DAYS = ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'];

export function formatDate(iso) {
    if (!iso) return '';
    const d = new Date(iso + 'T00:00:00');
    return `${d.getDate()}. ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateShort(iso) {
    if (!iso) return '';
    const d = new Date(iso + 'T00:00:00');
    return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}

export function dayName(iso) {
    if (!iso) return '';
    return DAYS[new Date(iso + 'T00:00:00').getDay()];
}

export function monthLong(iso) {
    if (!iso) return '';
    return MONTHS[new Date(iso + 'T00:00:00').getMonth()];
}

export function formatTime(t) {
    if (!t) return '';
    return t.slice(0, 5);
}

export function formatDuration(sec) {
    if (!sec) return '';
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
}

// YouTube ID z různých tvarů URL.
export function youtubeId(url) {
    if (!url) return '';
    const m = String(url).match(
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
    );
    return m ? m[1] : '';
}
